export default __webpack_public_path__ + "static/media/Icon026.aa9dda2c.png";